<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-shield-check" icon-small title="ثبت درخواست اعتبارسنجی آنلاین" color="accent" :loading="createLoading">
			<v-row class="pa-4">
				<v-col cols="12" md="3">
					<v-text-field v-model="form.nationalCode" label="کد ملی*" single-line hide-details="auto" :rules="[nationalCodeRule]" required />
				</v-col>
				<v-col cols="12" md="3">
					<v-text-field v-model="form.mobile" label="شماره موبایل*" single-line hide-details="auto" :rules="[mobileRule]" required />
				</v-col>
				<v-col cols="12" md="3">
					<v-text-field v-model="form.fullName" label="نام و نام خانوادگی" single-line hide-details="auto" />
				</v-col>
				<v-col cols="12" md="3" class="d-flex align-center justify-end">
					<v-btn color="primary" dark class="mx-1" :loading="createLoading" @click="createRequest">
						<v-icon left>mdi-send</v-icon>
						ثبت درخواست
					</v-btn>
				</v-col>
			</v-row>
			<v-divider />
			<div class="px-4 py-2 grey--text text-caption">
				در صورتی که کد ملی وارد شده در سامانه ثبت شده باشد، اطلاعات مشتری به صورت خودکار استفاده می گردد؛ در غیر این صورت اعتبارسنجی بدون نیاز به عضویت در سایت انجام می شود.
				پس از ثبت درخواست، کد مجوز پیامک شده برای شماره موبایل فوق ارسال می گردد.
			</div>
		</material-card>

		<material-card icon="mdi-format-list-numbered-rtl" icon-small title="لیست اعتبارسنجی های انجام شده" color="accent" :loading="loading">
			<v-row>
				<v-col cols="12" style="padding:0 40px 40px">
					<v-row>
						<v-col cols="12" md="3">
						</v-col>
						<v-col cols="12" md="6">
							<date-navigator v-model="dateRange" :options="{ rangeMode: true, defaultEmpty: true }">
								<div class="text-center">
									<v-btn color="primary" dark class="mx-1" @click="loadData">
										دریافت اطلاعات
									</v-btn>
								</div>
							</date-navigator>
						</v-col>
						<v-col cols="12" md="3" class="d-flex align-center justify-end">
							<export-excel :items="items" :headers="headers" :fileName="excelFileName">
							</export-excel>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" md="12">
							<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
						</v-col>
						<v-col cols="12">
							<v-data-table :height="dataTableFixedHeight - 100" fixed-header :headers="headers" :items="items" :footer-props="{ 'items-per-page-options': [5, 25, 50, 100] }" :items-per-page="50" :search="search" class="elevation-1">
								<template v-slot:item="row">
									<tr>
										<td>
											<div>{{ row.item.customerDisplayName }}</div>
											<div class="grey--text text-caption">{{ row.item.customerNationalCode }}</div>
										</td>
										<td class="text-center">
											{{ row.item.customerMobile }}
										</td>
										<td class="text-center">
											&lrm;{{ row.item.date_Persian.date }} {{ row.item.date_Persian.time }}
										</td>
										<td class="text-center">
											<div>{{ row.item.status_Str }}</div>
											<div class="grey--text text-caption">{{ row.item.isAdminRequest ? 'ثبت شده توسط ادمین' : 'ثبت شده توسط مشتری' }}</div>
										</td>
										<td class="text-center">
											{{ row.item.messages }}
										</td>
										<td class="text-center">
											{{ row.item.result }}
										</td>
										<td class="text-center">
											{{ row.item.gradeNumber }}
										</td>
										<td class="text-center">
											<a v-if="row.item.url" :href="row.item.url" target="_blank" style="text-decoration: none;font-size: 11px;" class="secondary--text link">مشاهده</a>
											<div v-else>-</div>
										</td>
										<td class="text-center">
											<a v-if="row.item.reportPdfFileName" :href="`/IranValidity/DownloadPdf/${row.item.id}`" target="_blank" style="text-decoration: none;font-size: 11px;" class="secondary--text link">دانلود</a>
											<div v-else>-</div>
										</td>
										<td class="text-center">
											<div class="d-flex flex-column align-center">
												<v-btn v-if="row.item.status === 1" x-small outlined color="primary" class="mb-1" @click="openOtpDialog(row.item)">
													ثبت کد مجوز
												</v-btn>
												<v-btn v-if="row.item.status === 1" x-small outlined color="primary" class="mb-1" :loading="renewLoading == row.item.id" @click="renewOtp(row.item)">
													ارسال مجدد
												</v-btn>
												<v-btn v-if="row.item.status === 2 || (row.item.status === 4 && !row.item.reportPdfFileName)" x-small outlined color="secondary" class="mb-1" :loading="statusLoading == row.item.id" @click="getStatus(row.item)">
													دریافت نتیجه
												</v-btn>
												<v-btn x-small outlined color="info" class="mb-1" @click="openGradeDialog(row.item)">
													ویرایش رتبه
												</v-btn>
											</div>
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</material-card>

		<v-dialog v-model="dialogOtp" scrollable persistent max-width="500px">
			<v-card>
				<v-card-title>
					<div><span class="headline">ثبت کد مجوز پیامکی</span></div>
					<v-spacer />
					<v-btn @click="dialogOtp = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<div class="mb-3 grey--text text-caption">
							کد مجوز ارسال شده به شماره {{ selectedReport ? selectedReport.customerMobile : '' }} را وارد نمایید.
						</div>
						<v-text-field v-model="otp" label="کد مجوز" single-line hide-details="auto" :rules="[(val) => !!val || 'کد مجوز را وارد کنید']" required />
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn @click="dialogOtp = false">انصراف</v-btn>
					<v-btn color="primary" dark :loading="otpLoading" @click="submitOtp">ثبت</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogGrade" scrollable persistent max-width="500px">
			<v-card>
				<v-card-title>
					<div><span class="headline">ویرایش رتبه اعتبارسنجی</span></div>
					<v-spacer />
					<v-btn @click="dialogGrade = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-select v-model="gradeForm.result" :items="grades" item-text="title" item-value="value" label="رتبه" />
						<v-text-field v-model.number="gradeForm.gradeNumber" label="رقم امتیاز" type="number" />
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn @click="dialogGrade = false">انصراف</v-btn>
					<v-btn color="primary" dark :loading="gradeLoading" @click="saveGrade">ذخیره</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'AdminIranValidity',
		components: {
			'date-navigator': () => import('@/components/DateNavigator'),
		},
		data() {
			return {
				loading: false,
				createLoading: false,
				otpLoading: false,
				renewLoading: '',
				statusLoading: '',
				gradeLoading: false,
				dialogOtp: false,
				dialogGrade: false,
				selectedReport: null,
				otp: '',
				form: {
					nationalCode: '',
					mobile: '',
					fullName: ''
				},
				gradeForm: {
					reportId: null,
					result: '',
					gradeNumber: 0
				},
				search: '',
				dateRange: { start: '', end: '' },
				items: [],
				headers: [
					{
						text: 'مشتری',
						align: 'start',
						sortable: true,
						value: 'customerDisplayName',
						width: '150'
					}, {
						text: 'موبایل',
						align: 'center',
						sortable: true,
						value: 'customerMobile',
						width: '120'
					}, {
						text: 'تاریخ',
						align: 'center',
						sortable: true,
						value: 'date_Persian',
						width: '100'
					}, {
						text: 'وضعیت',
						align: 'center',
						sortable: true,
						value: 'status_Str',
					}, {
						text: 'پیام',
						align: 'center',
						sortable: true,
						value: 'messages',
					}, {
						text: 'رتبه',
						align: 'center',
						sortable: true,
						value: 'result',
					}, {
						text: 'اعتبار',
						align: 'center',
						sortable: true,
						value: 'gradeNumber',
					}, {
						text: 'لینک گزارش',
						align: 'center',
						sortable: true,
						value: 'url',
					}, {
						text: 'دریافت pdf',
						align: 'center',
						sortable: true,
						value: 'reportPdfFileName',
					}, {
						text: 'عملیات',
						align: 'center',
						sortable: false,
						value: 'id',
					},
				],
				grades: [
					{ value: 'فاقد رتبه', title: 'فاقد رتبه' },
					{ value: 'A', title: 'A' },
					{ value: 'A1', title: 'A1' },
					{ value: 'A2', title: 'A2' },
					{ value: 'A3', title: 'A3' },
					{ value: 'B', title: 'B' },
					{ value: 'B1', title: 'B1' },
					{ value: 'B2', title: 'B2' },
					{ value: 'B3', title: 'B3' },
					{ value: 'C', title: 'C' },
					{ value: 'C1', title: 'C1' },
					{ value: 'C2', title: 'C2' },
					{ value: 'C3', title: 'C3' },
					{ value: 'D', title: 'D' },
					{ value: 'D1', title: 'D1' },
					{ value: 'D2', title: 'D2' },
					{ value: 'D3', title: 'D3' },
					{ value: 'E', title: 'E' },
					{ value: 'E1', title: 'E1' },
					{ value: 'E2', title: 'E2' },
					{ value: 'E3', title: 'E3' },
					{ value: 'F', title: 'F' },
					{ value: 'F1', title: 'F1' },
					{ value: 'F2', title: 'F2' },
					{ value: 'F3', title: 'F3' },
				]
			}
		},
		computed: {
			excelFileName() {
				let name = 'گزارش اعتبارسنجی ایران'
				if (this.dateRange.start)
					name += ' از ' + this.dateRange.start.toString().split('T')[0]
				if (this.dateRange.end)
					name += ' تا ' + this.dateRange.end.toString().split('T')[0]
				name += '.xls'
				return name
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			nationalCodeRule(val) {
				if (!val) return 'کد ملی را وارد کنید'
				if (!/^\d{10}$/.test(val.replace('-', '').replace(/ /g, ''))) return 'کد ملی باید 10 رقم باشد'
				return true
			},
			mobileRule(val) {
				if (!val) return 'شماره موبایل را وارد کنید'
				if (!/^09\d{9}$/.test(val.replace('-', '').replace(/ /g, ''))) return 'شماره موبایل معتبر نیست'
				return true
			},
			createRequest() {
				if (!this.nationalCodeRule(this.form.nationalCode) || !this.mobileRule(this.form.mobile)) {
					toast.error('اطلاعات وارد شده معتبر نمی باشد.')
					return
				}
				const mobile = this.form.mobile.replace('-', '').replace(/ /g, '')
				this.createLoading = true
				api.post('admin/IranValidityReport/Create', {
					nationalCode: this.form.nationalCode.replace('-', '').replace(/ /g, ''),
					mobile: mobile,
					fullName: this.form.fullName
				})
					.then(response => {
						toast.success('درخواست اعتبارسنجی با موفقیت ثبت شد.')
						this.form.nationalCode = ''
						this.form.mobile = ''
						this.form.fullName = ''
						this.loadData()
						if (response) {
							this.openReportDialog(response)
						}
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.createLoading = false
					})
			},
			loadData() {
				this.loading = true
				api.get('admin/IranValidityReport/List/?start=' + this.dateRange.start + '&end=' + this.dateRange.end, {})
					.then(response => {
						this.items = response
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			openOtpDialog(item) {
				this.selectedReport = item
				this.otp = ''
				this.dialogOtp = true
			},
			openReportDialog(id) {
				api.get('admin/IranValidityReport/Get/' + id, {})
					.then(report => {
						this.openOtpDialog(report)
					})
					.catch(err => {
						this.openOtpDialog({ id: id, customerMobile: '' })
					})
			},
			submitOtp() {
				if (!this.otp) {
					toast.error('کد مجوز را وارد کنید.')
					return
				}
				this.otpLoading = true
				api.post('admin/IranValidityReport/SubmitOTP/' + this.selectedReport.id + '/' + this.otp)
					.then(response => {
						toast.success('کد مجوز با موفقیت ثبت شد.')
						this.dialogOtp = false
						this.loadData()
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.otpLoading = false
					})
			},
			renewOtp(item) {
				this.renewLoading = item.id
				api.post('admin/IranValidityReport/RenewOTP/' + item.id)
					.then(response => {
						toast.success('کد مجوز مجدد ارسال شد.')
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.renewLoading = ''
					})
			},
			getStatus(item) {
				this.statusLoading = item.id
				api.get('admin/IranValidityReport/GetStatus/' + item.id)
					.then(response => {
						toast.success('نتیجه استعلام با موفقیت دریافت شد.')
						this.loadData()
					})
					.catch(err => {
						toast.error(err.message)
						this.loadData()
					})
					.finally(x => {
						this.statusLoading = ''
					})
			},
			openGradeDialog(item) {
				this.gradeForm.reportId = item.id
				this.gradeForm.result = item.result || 'فاقد رتبه'
				this.gradeForm.gradeNumber = item.gradeNumber || 0
				this.dialogGrade = true
			},
			saveGrade() {
				this.gradeLoading = true
				api.post('admin/IranValidityReport/SetGrade', {
					reportId: this.gradeForm.reportId,
					grade: this.gradeForm.result,
					gradeNumber: this.gradeForm.gradeNumber
				})
					.then(response => {
						toast.success('رتبه با موفقیت ثبت شد.')
						this.dialogGrade = false
						this.loadData()
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.gradeLoading = false
					})
			}
		}
	}
</script>

<style scoped>
	.link {
		text-decoration: none;
		font-size: 11px;
		padding: 3px;
		border-radius: 5px;
		border: 1px solid grey;
		margin-bottom: 3px;
		text-align: center;
	}
</style>
